/* SPDX-FileCopyrightText: Copyright (c) 2026 NVIDIA CORPORATION & AFFILIATES. All rights reserved. */
/* SPDX-License-Identifier: Apache-2.0 */

:host {
  --padding: var(--nve-ref-size-300) 0 var(--nve-ref-size-300) var(--nve-ref-size-400);
  --border-bottom: var(--nve-ref-border-width-sm) solid var(--nve-ref-border-color-muted);

  flex-grow: 1;
}

[internal-host] {
  padding: var(--padding);
  color: var(--color);
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  flex-grow: 1;
}

::slotted([slot='title']) {
  margin: 0;
  font-size: var(--nve-ref-font-size-200);
  font-weight: var(--nve-ref-font-weight-semibold);
}

::slotted([slot='subtitle']) {
  margin: 0;
  font-size: var(--nve-ref-font-size-100);
  font-weight: var(--nve-ref-font-weight-regular);
  color: var(--nve-sys-text-muted-color);
}

::slotted([slot='action-icon']) {
  margin-block-start: calc((var(--nve-ref-size-300) * -1) + var(--nve-ref-size-100)); /* not nve-ref-size-300 */
  align-self: self-start;
  z-index: 99;
}
